import { render, staticRenderFns } from "./OfficeFooter.vue?vue&type=template&id=86fd366e"
import script from "./OfficeFooter.vue?vue&type=script&lang=js"
export * from "./OfficeFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports